import React from 'react'
import { Redirect } from 'react-router-dom'

const ComingSoon: React.FC = () => {
  return <Redirect to="/" />
}

export default ComingSoon
